import QueryString from 'qs';
import {
  convertPaginationQueryStringToPaginationQuery,
  defaultPagination,
  IPaginationQuery,
} from '../../types/rest/IPaginationQuery';
import { compose } from '@reduxjs/toolkit';
import { convertLocationSearchToDataStringParams } from '../queryString';

// we cannot use the utility applyDefault Query because our default page size must be 100
const applyDefaultQuery = ({ pageNumber, pageSize }: IPaginationQuery): IPaginationQuery => {
  return {
    pageNumber: pageNumber || defaultPagination.pageNumber,
    pageSize: pageSize || 100,
  };
};

const convertFromQueryStringParamsToIPaginationQuery = (queryStringParams: QueryString.ParsedQs): IPaginationQuery => {
  const { pageNumber, pageSize } = queryStringParams;
  return convertPaginationQueryStringToPaginationQuery({
    pageNumber: pageNumber as string,
    pageSize: pageSize as string,
  });
};

export const initializeQueryStateUnderwriterProfiles = compose(
  applyDefaultQuery,
  convertFromQueryStringParamsToIPaginationQuery,
  convertLocationSearchToDataStringParams
);
